import React from 'react'

import backgroundImage from 'src/assets/login_background2.jpg'
import { useUI } from 'src/state/uiState'

const backgroundStyle = {
    background: `url(${backgroundImage})`,
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    width: '100vw',
    height: '100vh',
}

const AuthTemplate = ({ children }: { children: React.ReactNode }) => {
    const ui = useUI()
    return (
        <div className="flex h-screen w-screen overflow-auto">
            <div className="flex h-full w-full shrink-0 flex-col items-center justify-center overflow-auto bg-neutral-100 p-6 md:w-[28rem]">
                <div className="flex flex-col items-center overflow-auto rounded bg-white px-4 py-10">
                    <img src={ui.assets.logo} className="mb-12 h-fit w-1/2" alt="Logo" />
                    {children}
                </div>
            </div>
            <div style={backgroundStyle} />
        </div>
    )
}

export default AuthTemplate
